import React from 'react';
import { connect } from 'react-redux';
import {
    toggleShowAddParentOrgUnit,
    fetchOrgUnits,
    selectParentOrgUnit,
    addOrgUnitParent
} from './../../../reduxFiles/actionTypes';
import axios from 'axios';
import { toast } from 'react-toastify';
import { Item, Button, Label, Icon, Segment, Dropdown } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import parentIcon from './../college.svg';

axios.defaults.xsrfHeaderName = "X-XSRF-TOKEN";
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
//axios.defaults.crossDomain = true;

class OrgUnitParent extends React.Component {
    constructor(props) {
        super(props);
        this.showAddParent = this.showAddParent.bind(this);
        this.addParent = this.addParent.bind(this);

        if (this.props.isAddingParent) {
            this.props.dispatch(toggleShowAddParentOrgUnit());
        }
    }
    // TODO emir: i na frontu i na backu sprijeciti da se dodaje isti parent/tip its dva puta

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.orgUnitId !== nextProps.orgUnitId && this.props.isAddingParent) {
            this.props.dispatch(toggleShowAddParentOrgUnit());
        }
    }

    showAddParent() {
        this.props.dispatch(fetchOrgUnits());
        this.props.dispatch(toggleShowAddParentOrgUnit());
    }

    addParent() {
        this.props.dispatch(addOrgUnitParent(this.props.orgUnitId, this.props.parentOrgUnitIdToAdd));
    }

    render() {
        const {parents, isAddingParent, parentOrgUnitIdToAdd, orgUnits, addingParentError} = this.props;

        if (orgUnits.error) {
            toast(<FormattedMessage id='orgUnitDetailed.errors.gettingOrganizationalUnits'/>);
        }
        if (addingParentError) {
            toast(<FormattedMessage id='orgUnitDetailed.errors.addingParent'/>);
        }

        return (
        <Item>
            <Item.Image src={parentIcon} size='tiny'/>
            <Item.Content style={{paddingRight: '21px'}}>
                <Item.Header><AddOrgUnitParent showAddParent={this.showAddParent}/></Item.Header>
                <Item.Description>
                    {isAddingParent && orgUnits.items.length &&
                        <Segment raised>
                            <Dropdown clearable
                                onChange={(e, {value}) => this.props.dispatch(selectParentOrgUnit(value))}
                                fluid
                                search
                                selection
                                style={{marginBottom: '5px'}}
                                value={parentOrgUnitIdToAdd}
                                options={orgUnits.items.filter(orgUnit => (parents.find(parent => orgUnit.id === parent.id)) === undefined).map(orgUnit =>
                                    ({ key: orgUnit.id, value: orgUnit.id, text: orgUnit.name })
                                )}/>
                                <Icon circular name='check' onClick={this.addParent}/>
                                {/* TODO emir: implement */}
                                <Icon circular name='cancel' onClick={() => {this.props.dispatch(toggleShowAddParentOrgUnit());}}/>
                        </Segment>
                    }
                    <div style={{display: 'flex', flexWrap: 'wrap', alignContent: 'space-between'}}>
                        {parents.map((parent, index) =>
                            <Label as='a' key={index} onClick={this.props.onOrgUnitClicked} value={parent.id} style={{marginBottom: '5px'}}>
                                {parent.name}
                            </Label>
                        )}
                    </div>
                </Item.Description>
            </Item.Content>
        </Item>
        );
    }
}

const AddOrgUnitParent = props => (
    <Button as='div' labelPosition='left' onClick={(event, data) => {props.showAddParent()}}>
        <Label as='a' basic pointing='right'><FormattedMessage id='orgUnitDetailed.parents'/></Label>
        <Button icon>
            <Icon name='plus' />
        </Button>
    </Button>
)

function mapStateToProps(state) {
    return {
        isAddingParent: state.ui.orgUnitsView.parentView.isAddingParent,
        parentOrgUnitIdToAdd: state.ui.orgUnitsView.parentView.parentOrgUnitIdToAdd,
        orgUnits: state.data.orgUnits,
        isSendingParent: state.ui.orgUnitsView.parentView.isSendingParent,
        addingParentError: state.ui.orgUnitsView.parentView.addingParentError
    }
}

export default connect(mapStateToProps)(OrgUnitParent);



// WEBPACK FOOTER //
// ./src/views/OrganizationalUnit/components/OrgUnitParent.js